import React from 'react';

import { type OtpFormProps, SentOtpForm } from './utilities';

/**
 * Convenience wrapper for SMS-based {@link SentOtpForm}.
 */
export default function SmsOtpForm({
  onSuccess: handleSuccess,
  onFailure: handleFailure,
  isCodeReadyForSubmission,
  onSubmittableChange: handleSubmittableChange,
}: OtpFormProps): JSX.Element {
  return (
    <SentOtpForm
      isCodeReadyForSubmission={isCodeReadyForSubmission}
      sentFactorType='sms'
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      onSubmittableChange={handleSubmittableChange}
    />
  );
}
